import { render, staticRenderFns } from "./EventsByTournamentDetailsModal.vue?vue&type=template&id=35608677&scoped=true"
import script from "./EventsByTournamentDetailsModal.vue?vue&type=script&lang=js"
export * from "./EventsByTournamentDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35608677",
  null
  
)

export default component.exports